(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/matchstatistics/assets/javascripts/views/statlivestatistics.js') >= 0) return;  svs.modules.push('/components/statistics/matchstatistics/assets/javascripts/views/statlivestatistics.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};
  var log = new svs.core.log.Logger('svs.statistics.views.StatLiveStatistics');

  svs.statistics.views.StatLiveStatistics = Backbone.View.extend({
    tagName: 'div',
    classId: 'StatLiveStatistics',
    viewId: 'statistik',
    SPORT_HOCKEY: 'sport-hockey',
    SPORT_SOCCER: 'sport-soccer',
    SPORT_FLOORBALL: 'sport-floorball',
    inited: false,

    events: {
      'change #liveStatisticsFilter': 'selectMenu'
    },

    initialize: function(options) {
      this.modelReference = options.modelReference;
      this.options = options.options;
      this.listenTo(this.modelReference, 'periodSelected', this.rerender);
    },

    rerender: function() {
      this.render();
    },

    update: function(model) {
      this.modelReference = model;
      this.render({});
    },

    beforeRender: function() {
      if (this.inited) {
        return;
      }
      var statistics = this.modelReference.get('statistics');
      if (((statistics || {}).sport || {}).id) {
        var id = statistics.sport.id;
        this.setupCircleGraphs(id);
      }
      this.inited = true;
    },

    render: function() {
      if (!_.isObject(this.modelReference.get('statistics'))) return this;

      this.beforeRender();
      var statistics = this.modelReference.get('statistics');
      if (!_.isObject(statistics.sport)) {
        return this;
      }

      var id = statistics.sport.id;
      var _self = this,
        componentFile = 'stat-live-statistics',
        theme;
      theme = new svs.sport.themeLoader({
        sport: id
      });
      theme.load(function(template, init) {
        if (!template) {
          return _self;
        }
        _self.template = template;

        _self.$el.html(_self.template(_self.applyFilters()));

        $(function() {
          _self.afterRender();
        });

        if (init) {
          init(componentFile);
        }
        return this;
      }, componentFile);
    },

    afterRender: function() {
      var liveStatistics = this.modelReference.get('statistics');
      this.updateLiveStatistics(liveStatistics);
      this.resize();
    },

    getTemplateFunction: function(func, data) {
      var returner = false,
        theme;
      theme = new svs.sport.themeLoader({
        sport: data.sport.id
      });
      theme.load(function(template, init) {
        if (init) {
          returner = init(func, data);
        }
      }, 'init');
      return returner;
    },

    resize: function() {
      if (Object.prototype.hasOwnProperty.call(this.options.params, 'parent')) {
        this.options.params.parent.trigger('resize');
      }
    },

    applyFilters: function() {
      var liveStatistics = this.modelReference.get('statistics');

      return {
        liveStatistics: liveStatistics
      };
    },

    selectMenu: function(ev) {
      log.debug('selectMenu ' + ev.currentTarget.selectedIndex, ev);
      this.modelReference.setPeriodSelected(ev.currentTarget.selectedIndex);
    },

    updateLiveStatistics: function(liveStatistics, playAnimation) {
      var KEY_SHOOT_ON_GOAL = 'Skott på mål';
      var KEY_SAVE_PERCENTAGE = 'Räddningsprocent';
      var KEY_SHOOT_OUTSIDE_GOAL = 'Missade skott';
      var _self = this;
      var hockeyFloorballData = {
          savePercentageHomeTeam: 0,
          savePercentageAwayTeam: 0,
          shootsOnGoalHomeTeam: 0,
          shootsOnGoalAwayTeam: 0,
          shootsOutsideGoalHomeTeam: 0,
          shootsOutsideGoalAwayTeam: 0
        },
        soccerData = {},
        tennisData = {};

      if ((liveStatistics || {}).matchStatistics) {
        _.each(liveStatistics.matchStatistics, function(statsItem) {
          if (_.isObject(statsItem)) {
            if (statsItem.name === KEY_SHOOT_ON_GOAL) {
              if (_.has(statsItem, 'home')) {
                hockeyFloorballData.shootsOnGoalHomeTeam = _self.formatStatValue(
                  statsItem.home
                );
              }

              if (_.has(statsItem, 'away')) {
                hockeyFloorballData.shootsOnGoalAwayTeam = _self.formatStatValue(
                  statsItem.away
                );
              }
            } else if (statsItem.name === KEY_SHOOT_OUTSIDE_GOAL) {
              if (_.has(statsItem, 'home')) {
                hockeyFloorballData.shootsOutsideGoalHomeTeam = _self.formatStatValue(
                  statsItem.home
                );
              }
              if (_.has(statsItem, 'away')) {
                hockeyFloorballData.shootsOutsideGoalAwayTeam = _self.formatStatValue(
                  statsItem.away
                );
              }
            } else if (statsItem.name === KEY_SAVE_PERCENTAGE) {
              if (_.has(statsItem, 'home')) {
                hockeyFloorballData.savePercentageHomeTeam = _self.formatStatValue(
                  statsItem.home
                );
              }
              if (_.has(statsItem, 'away')) {
                hockeyFloorballData.savePercentageAwayTeam = _self.formatStatValue(
                  statsItem.away
                );
              }
            }

            if ((statsItem || {}).name) {
              if (statsItem.name.toLowerCase() === 'bollinnehav') {
                if (_.has(statsItem, 'home')) {
                  soccerData.home = _self.formatStatValue(statsItem.home);
                }

                if (_.has(statsItem, 'away')) {
                  soccerData.away = _self.formatStatValue(statsItem.away);
                }
              }
            }
          }
        });

        if (((liveStatistics || {}).sport || {}).id) {
          var id = liveStatistics.sport.id;
          _self.updateCircleGraphs(
            id,
            soccerData,
            hockeyFloorballData,
            playAnimation
          );
        }
        return {
          soccerData: soccerData,
          hockeyFloorballData: hockeyFloorballData,
          tennisData: tennisData
        };
      }
    },

    formatStatValue: function(statsValue) {
      var res = null;
      if (typeof statsValue === 'string') res = statsValue.replace(',', '.');
      else if (typeof statsValue === 'number') res = statsValue;
      else return res;
      return Math.round(res);
    },

    retrieveSportById: function(sportId) {
      return new svs.sport.themeLoader().retrieveSportById(sportId);
    },

    setupCircleGraphs: function(sportId) {
      var currentSportId = this.retrieveSportById(sportId);
      switch (currentSportId) {
        case this.SPORT_FLOORBALL:
          this.shotsOnGoalChart = new svs.sport.circle_graph.views.CircleGraph({
            homeTeam: 0,
            awayTeam: 0,
            width: 400,
            height: 400,
            id: 'shotsOnGoalChart'
          });
          break;
        case this.SPORT_HOCKEY:
          this.shotsOutsideGoalChart = new svs.sport.circle_graph.views.CircleGraph(
            {
              homeTeam: 0,
              awayTeam: 0,
              width: 400,
              height: 400,
              id: 'shotsOutsideGoalChart'
            }
          );
          this.shotsOnGoalChart = new svs.sport.circle_graph.views.CircleGraph({
            homeTeam: 0,
            awayTeam: 0,
            width: 400,
            height: 400,
            id: 'shotsOnGoalChart'
          });
          break;
        case this.SPORT_SOCCER:
          this.circleChart = new svs.sport.circle_graph.views.CircleGraph({
            homeTeam: 0,
            awayTeam: 0,
            width: 400,
            height: 400,
            id: 'circleChart'
          });
          break;
        default:
          break;
      }
    },

    updateCircleGraphs: function(
      sportId,
      soccerData,
      hockeyFloorballData,
      playAnimation
    ) {
      var _self = this,
        currentSportId = this.retrieveSportById(sportId);
      if (
        currentSportId === this.SPORT_HOCKEY ||
        currentSportId === this.SPORT_FLOORBALL
      ) {
        if (
          _self.shotsOnGoalChart &&
          _self.shotsOnGoalChart instanceof
            svs.sport.circle_graph.views.CircleGraph
        ) {
          var shootsOnGoalPercentage =
            (hockeyFloorballData.shootsOnGoalHomeTeam /
              (hockeyFloorballData.shootsOnGoalHomeTeam +
                hockeyFloorballData.shootsOnGoalAwayTeam)) *
            100;
          _self.shotsOnGoalChart.update({
            homeTeam: hockeyFloorballData.shootsOnGoalHomeTeam,
            awayTeam: hockeyFloorballData.shootsOnGoalAwayTeam,
            percentage: shootsOnGoalPercentage,
            graphType: this.SPORT_HOCKEY
          });
        }

        if (currentSportId === this.SPORT_HOCKEY) {
          if (
            _self.shotsOutsideGoalChart &&
            _self.shotsOutsideGoalChart instanceof
              svs.sport.circle_graph.views.CircleGraph
          ) {
            var shootsOutsideGoalPercentage =
              (hockeyFloorballData.shootsOutsideGoalHomeTeam /
                (hockeyFloorballData.shootsOutsideGoalHomeTeam +
                  hockeyFloorballData.shootsOutsideGoalAwayTeam)) *
              100;
            _self.shotsOutsideGoalChart.update({
              homeTeam: hockeyFloorballData.shootsOutsideGoalHomeTeam,
              awayTeam: hockeyFloorballData.shootsOutsideGoalAwayTeam,
              percentage: shootsOutsideGoalPercentage,
              graphType: this.SPORT_HOCKEY
            });
          }
        }
      } else if (this.retrieveSportById(sportId) === this.SPORT_SOCCER) {
        if (
          _self.circleChart &&
          _self.circleChart instanceof svs.sport.circle_graph.views.CircleGraph
        ) {
          _self.circleChart.update({
            homeTeam: soccerData.home,
            awayTeam: soccerData.away,
            percentage: false,
            playAnimation: playAnimation,
            graphType: this.SPORT_SOCCER
          });
        }
      }
    },

    onDestroy: function() {
      if (this.shotsOnGoalChart) {
        this.shotsOnGoalChart.dispose();
      }

      if (this.shotsOutsideGoalChart) {
        this.shotsOutsideGoalChart.dispose();
      }

      if (this.circleChart) {
        this.circleChart.dispose();
      }

      this.undelegateEvents();
      this.modelReference.off();
      this.remove();

      delete this.shotsOnGoalChart;
      delete this.shotsOutsideGoalChart;
      delete this.circleChart;
      delete this.$el;
      delete this.el;
    }
  });
})(Backbone, _, svs);

 })(window);